// import { configFactory } from '../utils';

const common = {
  clientDateFormat: 'YYYY-MM-DD',
  clientShortDateFormat: 'M/D/YY',
  serverDateFormat: 'YYMMDD',
  serverWithTimeDateFormat: 'MM/DD/YY HH:mm:ss',
};

const configFactory = (config, env = process.env.NODE_ENV) => {
  if (config[env] !== undefined) {
    return config[env];
  } else if (config.development) {
    // logger.warn({
    //   label: 'configFactory',
    //   message: `We couldn't find a config for the ENV ${env}. Using DEV's config as the default.`,
    // });

    return config.development;
  }

  // logger.warn({
  //   label: 'configFactory',
  //   message: `We couldn't find a config for the ENV ${env}. Returning the entire config object.`,
  // });

  return config;
};

export default configFactory({
  development: {
    ...common,
  },
  production: {
    ...common,
  },
});
